import React from 'react';
import { Reveal, SectionLabel } from './Section';
import { CAREER_ROLES, INCLUDED } from '../data/content';
import { CheckCircle2 } from 'lucide-react';

export default function Careers() {
  const doubled = [...CAREER_ROLES, ...CAREER_ROLES];
  return (
    <>
      <section className="py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal><SectionLabel>Career Opportunities</SectionLabel></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[68px] leading-[1.02] font-semibold text-[#293891] mt-6 max-w-4xl">
              15 roles. One skillset. <span className="text-[#E63329]">Yours.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-[#293891]/75">
              Structured placement assistance opens doors across the entire Data Science, Machine Learning and AI landscape.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 overflow-hidden">
          <div className="flex gap-6 whitespace-nowrap animate-marquee">
            {doubled.map((r,i) => (
              <div key={i} className="font-display text-[28px] sm:text-[42px] font-semibold text-[#293891]/85 flex items-center gap-6 shrink-0">
                {r}<span className="text-[#E63329] text-[22px]">✦</span>
              </div>
            ))}
          </div>
          <div className="flex gap-6 whitespace-nowrap animate-marquee-slow mt-6" style={{direction:'rtl'}}>
            {doubled.map((r,i) => (
              <div key={i} className="font-display text-[28px] sm:text-[42px] font-semibold text-[#293891]/50 flex items-center gap-6 shrink-0" style={{direction:'ltr'}}>
                {r}<span className="text-[#293891] text-[22px]">✦</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1.15fr_1fr] gap-14">
          <div>
            <Reveal><SectionLabel>Everything Included</SectionLabel></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[62px] leading-[1.02] font-semibold text-[#293891] mt-6">
                Everything in your <span className="text-[#E63329]">learning journey.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-[15px] leading-relaxed text-[#293891]/75 max-w-lg">
                One program, everything you need — from your first live class to your first Data Science offer.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10">
                <div className="font-display text-[72px] sm:text-[92px] leading-none font-semibold text-[#293891]">1 <span className="text-[#E63329]">program.</span></div>
                <div className="font-display text-[42px] leading-none font-semibold text-[#293891]/40 mt-2">everything you need.</div>
              </div>
            </Reveal>
          </div>

          <div className="bg-[#F4F5FB] border border-[#293891]/10 rounded-3xl p-8 lg:p-10">
            <ul className="space-y-4">
              {INCLUDED.map((it,i) => (
                <Reveal key={it} delay={i*0.04}>
                  <li className="flex items-start gap-3">
                    <CheckCircle2 className="text-[#E63329] shrink-0 mt-0.5" size={20}/>
                    <span className="text-[14px] text-[#293891]/85">{it}</span>
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
